import classNames from 'classnames';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { NAVIGATION_LAYOUT } from '../../../brands/default/constants';
import { hashCode } from '../../../helpers/hash';
import ThemeContext from '../../../providers/ThemeProvider';

const CategoryItem = ({ categoryArray, categoryLink, categoryName }) => {
  const theme = useContext(ThemeContext);

  if (!categoryArray) {
    return null;
  }

  const groupRedirectLink = categoryLink.find(
    (item) => Object.keys(item)[0] === categoryName,
  )?.[categoryName];

  return (
    <>
      {groupRedirectLink ? (
        <Link href={groupRedirectLink ?? ''}>
          <a className="heading-navigation-popover__link">{categoryName}</a>
        </Link>
      ) : (
        <h3>{categoryName}</h3>
      )}
      <ul className="navigation-popover__list">
        {categoryArray.map((item, index) => (
          <li key={`HNP_li_${index}_${hashCode()}`}>
            <Link href={item.url ?? ''}>
              <a
                className={classNames(
                  NAVIGATION_LAYOUT.highlightedCat.includes(item.linkText)
                    ? 'highlight-navigation-popover__link'
                    : 'navigation-popover__link',
                )}
              >
                {item.linkText} {item.count && `(${item.count})`}
              </a>
            </Link>
          </li>
        ))}
      </ul>

      <style jsx>{`
        .navigation-popover__column {
          padding: 0 15px;
          border-right: 1px solid #cccccc;
          flex-grow: 1;
          flex-basis: 0;
        }
        .heading-navigation-popover__link {
          color: #000000;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
        }
        .heading-navigation-popover__link:hover {
          color: ${theme.colors.navlinkactive};
          cursor: pointer;
        }
        .highlight-navigation-popover__link {
          font-weight: 600;
          color: #000000;
        }
        .highlight-navigation-popover__link:hover {
          color: ${theme.colors.navlinkactive};
        }
        .navigation-popover__list {
          list-style: none;
          padding: 0;
        }
        .navigation-popover__link {
          color: #000000;
        }
        .navigation-popover__link--small-only {
          display: none;
        }
        .navigation-popover__link:hover {
          color: ${theme.colors.navlinkactive};
        }
        .cursor-pointer {
          cursor: pointer;
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .navigation-popover__link--small-only {
            display: block;
          }
        }
      `}</style>
    </>
  );
};

CategoryItem.propTypes = {
  categoryArray: PropTypes.object,
  categoryLink: PropTypes.array,
  categoryName: PropTypes.string,
};

export default CategoryItem;
